import React from 'react'
import ProdTaskWastageRow from './ProdTaskWastageRow'
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import { UiAction, UiTitle, UiView, UiViewContent, UiViewHeading } from "../../../../../library/layout/Index";

const ProdTaskWastage = (props) => {
    const { formObject, viewData } = props;

    console.log("task row", viewData);

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <FormROValue formObject={formObject} rowKey="" action={{ paramName: "processName" }} />
                </UiTitle>
                
                <UiAction>
                    <div className="phAction">
                        <FormButton formObject={formObject} rowKey="" className="uiActionIconButton" starIcon={"adds"}
                            action={{ actionId: "new",  actionParam: {}, containerKey: "row" }}
                            text={<SarasTrans value="Add Wastage" />}
                        />
                    </div>
                </UiAction>
            </UiViewHeading>
            <UiViewContent>
                <ul className="uiListTable" style={{backgroundColor:"#FFF"}}>
                    <li className="uiSearchHeading">
                        <ul>
                            <li className="uiColumnCenter uiColumn30"><SarasTrans value="Sr No." /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Item Id" /></li>
                            <li className="uiColumnCenter uiColumn150"><SarasTrans value="Item Name" /></li>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                            <li className="uiColumnCenter uiColumn50 uiSpacerH10"><SarasTrans value="Qty Issued" /></li>
                            <li className="uiColumnCenter uiColumn50 uiSpacerH10"><SarasTrans value="Qty Wasted" /></li>
                            <li className="uiColumnCenter uiColumn50 uiSpacerH10"><SarasTrans value="Qty Damaged" /></li>
                            <li className="uiColumnCenter uiColumn50 uiSpacerH10"><SarasTrans value="Qty Lost" /></li>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="% Waste" /></li>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="% Allow" /></li>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Qty Allow" /></li>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Wastage after Allow" /></li>
                            <li className="uiColumnCenter uiColumn70"><SarasTrans value="Unit Cost" /></li>
                            <li className="uiColumnCenter uiColumn70"><SarasTrans value="Total Wastage Value" /></li>
                            <li className="uiColumnCenter uiColumn70"><SarasTrans value="Total Deduction" /></li>
                            <li className="uiColumnCenter uiColumn150"><SarasTrans value="Remark" /></li>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Action" /></li>
                        </ul>
                    </li>
                    {
                        Object.values(viewData ? viewData : {}).map((row, index) => (
                            <li><ProdTaskWastageRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1} /></li>
                        ))
                    }
                </ul>
            </UiViewContent>
        </UiView>
    )
}

export default withView(ProdTaskWastage, "prodTaskWaste", "");
